import { Grid, Typography } from '@mui/material';
import lottie from '../img/loader.json'
import Lottie from 'react-lottie-player';

// Make Loader accept props to customize margin/positioning
const Loader = ({ message = "Loading...", marginTop = '10vh' }) => {
    return (
        <Grid
            container
            direction="row"
            alignItems="center"
            justifyContent="center"
            sx={{marginTop: marginTop}}
        >
            <Grid item>
                <Lottie
                    loop
                    animationData={lottie}
                    play
                    speed={0.3}
                    style={{ width: 300, height: 300 }}
                />
                <Typography
                    variant="h5"
                    sx={{ color: 'black', textAlign: 'center' }}
                >
                    {message}
                </Typography>
            </Grid>
        </Grid>
    )
}

export default Loader;